import { RegisterRequestedFieldType } from "../requested-field-types"
import { RequestedFieldEditor, RequestedFieldInput, RequestedFieldValue } from "../share-link-fields-slot-definitions"
import { ChoiceFieldInput } from "../choice-field-input"
import { ChoiceFieldValue } from "../choice-field-value"
import { ChoiceOptionsEditor } from "../choice-options-editor"

/**
 * Self-registering plugin for the "choice" requested-field type. Registers the type's metadata, plugs
 * its recipient input + read-only value renderers, and the builder per-type extra (the options editor
 * shown under the row in the requested-information editor).
 */
RegisterRequestedFieldType.handleOnce(({ types }) => types.push({ value: "choice", label: "Choice", priority: 60 }))

RequestedFieldInput("choice").plug(<ChoiceFieldInput />)
RequestedFieldValue("choice").plug(<ChoiceFieldValue />)
RequestedFieldEditor("choice").plug(<ChoiceOptionsEditor />)
